let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("d2MIY")).then(() => parcelRequire('2ICev'));